export default __webpack_public_path__ + "static/media/property_858.50cd4700.png";